import { createFileRoute } from "@tanstack/react-router";

import { NotFoundContent } from "@/components/not-found";

export const Route = createFileRoute("/not-found")({
  head: () => ({
    meta: [{ title: "Page Not Found" }],
  }),
  component: NotFoundContent,
});
